import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { store } from "./redux/store";
import "./i18n";

import App from "./App";
// import * as serviceWorker from './serviceWorker';
//

ReactDOM.render(
    <React.StrictMode>
        <Provider store={store}>
            {/* <PersistGate loading={null} persistor={persister}> */}
            <BrowserRouter>
                <App />
            </BrowserRouter>
            {/* </PersistGate> */}
        </Provider>
    </React.StrictMode>,
    document.getElementById("root")
);
//  serviceWorker.register("");
